import useDataLayer from 'utils/dataLayer/useDataLayer';

export default function DataLayer() {
  useDataLayer();

  return null;
}
